import { InstallmentSummaryStateType } from '~/modules/addListing/types';
import clampMonths from '~/modules/addListing/pages/PriceStep/utils/clampMonths';
import clampYears from '~/modules/addListing/pages/PriceStep/utils/clampYears';
import roundToHalf from '~/modules/addListing/pages/PriceStep/utils/roundToHalf';
import roundToMonth from '~/modules/addListing/pages/PriceStep/utils/roundToMonth';
import {
  DAYS_IN_YEAR,
  MONTHS_IN_YEAR,
  NUMBER_DAYS_IN_MONTH,
} from '~/modules/addListing/pages/PriceStep/utils/constants';

export const getInstallmentDetails = ({
  downPayment: rawDownPaymentValue,
  downPaymentType,
  duration,
  installmentPeriodType,
  overPrice: overPriceValue,
  price,
}: InstallmentSummaryStateType) => {
  const contractPrice = Number(price) || 0;
  const overPrice = Number(overPriceValue) || 0;
  const totalPropertyPrice = contractPrice + overPrice;
  const rawDownPayment = Number(rawDownPaymentValue) || 0;
  const downPayment =
    downPaymentType === 'amount'
      ? rawDownPayment
      : Math.round((rawDownPayment / 100) * contractPrice);
  const totalRequiredPriceForBuyer = downPayment + overPrice;
  const remainingAmount = contractPrice - downPayment;
  const durationInDays = Number(duration) || 0;
  const installmentYears = durationInDays
    ? roundToHalf(durationInDays / DAYS_IN_YEAR)
    : 0;
  const installmentMonthsValue = durationInDays
    ? roundToMonth(durationInDays / NUMBER_DAYS_IN_MONTH)
    : 0;
  const displayYears = installmentYears ? clampYears(installmentYears) : 0;
  const displayMonths = installmentMonthsValue
    ? clampMonths(installmentMonthsValue)
    : 0;
  const installmentMonths =
    installmentPeriodType === 'months'
      ? displayMonths
      : displayYears * MONTHS_IN_YEAR;
  const installmentPeriod = clampYears(
    roundToHalf(durationInDays / DAYS_IN_YEAR),
  );
  const monthlyInstallment = installmentMonths
    ? remainingAmount / installmentMonths
    : 0;

  return {
    contractPrice,
    displayMonths,
    displayYears,
    downPayment,
    durationInDays,
    installmentMonths,
    installmentMonthsValue,
    installmentPeriod,
    installmentYears,
    monthlyInstallment,
    overPrice,
    rawDownPayment,
    remainingAmount,
    totalPropertyPrice,
    totalRequiredPriceForBuyer,
  };
};

export default getInstallmentDetails;
